function openModal(url) {
  document.getElementById('iframeContent').src = url;
  document.getElementById('roomTourModal').style.display = 'block';
  document.getElementById('roomTourOverlay').style.display = 'block';
  document.body.classList.add('overflow-hidden');
}

function closeModal() {
  document.getElementById('roomTourModal').style.display = 'none';
  document.getElementById('roomTourOverlay').style.display = 'none';
  document.getElementById('iframeContent').src = '';
  document.body.classList.remove('overflow-hidden');
}

document.addEventListener('DOMContentLoaded', () => {
  const accomodationsDialog = document?.querySelector('#roomTourModal');
  if (accomodationsDialog) {
    const roomTourLink = '.c-button--tour';
    const roomTourCloseBtn = '.accomodations__dialog__button';

    document.querySelectorAll(roomTourLink).forEach((item) => {
      item?.addEventListener('click', (e) => {
        e.preventDefault();
        const iframeLink = e.target.href;
        openModal(iframeLink);
      });
    });

    document.querySelector(roomTourCloseBtn)?.addEventListener('click', closeModal);
    document.querySelector('.accomodations__dialog__overlay').addEventListener('click', closeModal);

    document.addEventListener('click', (event) => {
      if (event.target === document.getElementById('roomTourModal')) {
        closeModal();
      }
    });
  }
});
